import {
  GET_PRODUCT_SUCCESS,
  GET_PRODUCT_ERROR,
  GET_PRODUCT_LIST_SUCCESS,
  GET_PRODUCT_LIST_ERROR,
} from "./actionTypes"

const statuslist = {
  idle: "idle",
  process: "process",
  success: "success",
  error: "error",
}

const INIT_STATE = {
  data: {},
  list: [],
  error: {},
  errorList: {},
  status: statuslist.idle,
}

const Product = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PRODUCT_SUCCESS:
      return {
        ...state,
        data: action.payload?.data,
        status: statuslist[action.payload.status],
      }

    case GET_PRODUCT_ERROR:
      return {
        ...state,
        data: {},
        error: action.payload?.data,
        status: statuslist.error,
      }
    case GET_PRODUCT_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload?.data,
        status: statuslist[action.payload.status],
      }
    case GET_PRODUCT_LIST_ERROR:
      return {
        ...state,
        list: {},
        errorList: action.payload?.data,
        status: statuslist.error,
      }
    default:
      return state
  }
}

export default Product
